import fetch from 'cross-fetch';
import * as uuid from 'uuid';
import BigBrainClient from './lib/BigBrainClient';

export const bigBrain = (env, appName) => new BigBrainClient(env, appName, console, fetch, uuid);
